import MotionSection from "../common/MotionSection";
import ActionLink from "../common/ActionLink";
import siteConfig from "../../data/siteConfig.json";

function TestimonialsFinalCta() {
  return (
    <MotionSection className="pb-20 pt-8 md:pb-24 md:pt-12">
      <div className="mx-auto w-full max-w-7xl px-6">
        <div className="relative overflow-hidden rounded-[2rem] bg-cta-glow px-6 py-12 text-center md:px-10 md:py-16">
          <div className="absolute -left-16 top-0 h-56 w-56 rounded-full bg-white/12 blur-3xl" />
          <div className="absolute -right-16 bottom-0 h-56 w-56 rounded-full bg-warm-gold/20 blur-3xl" />

          <div className="relative mx-auto max-w-3xl">
            <h2 className="text-2xl text-soft-white sm:text-3xl md:text-5xl">Ready to Start Your Own Success Story?</h2>
            <p className="mt-5 text-sm leading-relaxed text-sky-glow/85 sm:text-base md:text-lg">
              Let our team help you plan your overseas education path with confidence, clarity, and expert support.
            </p>

            <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <ActionLink
                variant="ctaPrimary"
                to={siteConfig.links.bookCounselling}
                label="Book Free Counselling"
              />
              <ActionLink variant="ctaSecondary" to="/contact" label="Contact Us" showArrow={false} />
            </div>
          </div>
        </div>
      </div>
    </MotionSection>
  );
}

export default TestimonialsFinalCta;
